import React from 'react';
import { FormTheme } from '../../types';

interface CheckboxProps {
  id: string;
  label: string;
  required?: boolean;
  value: boolean;
  onChange: (value: boolean) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  theme: FormTheme;
  /**
   * config.linkText — texto del enlace dentro del label
   * config.linkUrl  — URL del enlace
   */
  config: Record<string, any>;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id, label, required, value, onChange, onFocus, onBlur,
  error, disabled, config,
}) => {
  const { linkText, linkUrl } = config;

  const renderLabel = () => {
    if (linkText && linkUrl) {
      const parts = label.split(linkText);
      if (parts.length >= 2) {
        return <>{parts[0]}<a href={linkUrl} target="_blank" rel="noopener noreferrer">{linkText}</a>{parts.slice(1).join(linkText)}</>;
      }
    }
    return label;
  };

  return (
    <div className="hexaforms-field">
      <label className={`hexaforms-checkbox-wrapper${disabled ? ' hexaforms-checkbox-disabled' : ''}`}>
        <input
          type="checkbox"
          id={id}
          checked={value}
          onChange={e => onChange(e.target.checked)}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          required={required}
          className="hexaforms-checkbox-native"
        />
        <span className="hexaforms-checkbox-label">
          {renderLabel()}
          {required && <span className="hexaforms-required"> *</span>}
        </span>
      </label>
      {error && <div className="hexaforms-error">{error}</div>}
    </div>
  );
};
